import { Spinner } from '@/shared/ui'

export const AvailableWeekCalendarFallback = () => {
  return (
    <div className="flex w-100 grow items-center justify-center p-6">
      <p className="typo-body1 text-center font-medium text-gray-400">
        일정을 가져오는 중 오류가 발생했습니다.
        <br />
        잠시 후 다시 시도해 주세요.
      </p>
    </div>
  )
}

export const ScheduleCalendarFallback = () => {
  return (
    <div className="flex w-100 grow items-center justify-center border-r border-gray-100 p-6">
      <p className="typo-body1 text-center font-medium text-gray-400">
        일정을 가져오는 중 오류가 발생했습니다.
        <br />
        잠시 후 다시 시도해 주세요.
      </p>
    </div>
  )
}

export const CalendarLoadingFallback = () => {
  return (
    <div className="relative flex w-100 grow items-center justify-center">
      <Spinner />
    </div>
  )
}

export const CalendarDialogErrorFallback = () => {
  return (
    <div className="mb-6 flex w-200 grow items-center justify-center">
      <p className="typo-body1 text-center font-medium text-gray-400">
        일정을 가져오는 중 오류가 발생했습니다.
        <br />
        잠시 후 다시 시도해 주세요.
      </p>
    </div>
  )
}

export const CalendarDialogLoadingFallback = () => {
  return (
    <div className="relative flex w-200 items-center justify-center">
      <Spinner />
    </div>
  )
}
